export enum StepAction {
  PROCESS_FINISHED = 'PROCESS_FINISHED',
  CLOSE = 'CLOSE',
}
